export const EIGHT_BASE = {
  auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev-8lo26de64qqp1i28.us.auth0.com',
  auth0SpaClientId: process.env.REACT_APP_AUTH0_CLIENT_ID || 'UplJIwoCM8CxUzwmUSefUhSD3Gbi6VR8',
  apiEndpoint: process.env.REACT_APP_8BASE_API_URL || 'https://api.8base.com/cmd8pt1p0000002jr5q1xhqut',
  apiToken: process.env.REACT_APP_8BASE_API_TOKEN || '864747e1-0e80-445b-8fe4-434f367ff48e',
  workspaceId: process.env.REACT_APP_8BASE_WORKSPACE_ID || 'cmd8pt1p0000002jr5q1xhqut',
  environmentName: process.env.REACT_APP_8BASE_ENVIRONMENT_NAME || 'production',
}; 